import { createContext, useContext } from 'react';

import type { IActions } from '../interface/IAction';
import type { IStates } from '../interface/IReducer';

export interface IRedux {
	states: IStates;
	actions: IActions;
}

export const ReduxContext = createContext<IRedux | null>(null);

export const useReduxContext = (): IRedux => {
	const reduxContext = useContext(ReduxContext);

	if (!reduxContext) {
		throw new Error('useGlobalContext must be used within a GlobalProvider');
		// } catch (error) {}
	}

	return {
		...reduxContext,
	};
};
